import { mapState } from 'vuex'
import filter from 'js/filter'
import {
  Achecksendmobliecode,
  Alogin
} from '@/service/app'
const MOBILE_REGEX = /^1[3-9]\d{9}$/;
const loginCommon = {
  data() {
    const _this = this
    return {
      readSingle: true,

      readSingle: false,
      visible: false,
      readSingle2: false,
      visible2: false,

      codeStatus: 0,
      waitInterval: '',
      wait: 60,
      ncStatus: false,

      loginNumber: {
        id: 1,
        mobileAreaCode: '86',
        countryName: '中国',
      },

      successCb: '',
      ruleValidate: {
        code: [{ required: true, message: filter.dealLanguage('请填写正确的验证码', 'Please fill in the correct verification code'), trigger: 'blur' }],
        mobileVerifyCode: [{ required: true, message: filter.dealLanguage('请填写正确的验证码', 'Please fill in the correct verification code'), trigger: 'blur' }],
        mobile: [
          { required: true, message: filter.dealLanguage('请输入您的手机号', 'Please enter your mobile number'), trigger: 'blur' },
          {
            type: 'number',
            message: filter.dealLanguage('手机号格式不正确', 'The phone number format is incorrect'),
            trigger: 'blur',
            transform(value) {
              if (_this.loginNumber.mobileAreaCode == '86')
                return MOBILE_REGEX.test(value) ? Number(value) : false
            },
          },
        ],
      }
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      index2_path: (state) => state.index2_path,
      index_path: (state) => state.index_path,
      img_req_url: (state) => state.img_req_url,
      isMobile: (state) => state.isMobile,
      appMobileAreaCodeDtos: (state) => state.appMobileAreaCodeDtos,
      loginWxAppId: (state) => state.loginWxAppId,
    }),

  },
  methods: {
    beginLogin(cb = '') {
      this.successCb = cb
      this.modelIndex = true
    },
    handleSubmit() {
      this.$refs['code-form'].validate(async (valid) => {
        if (valid) {
          if (!this.readSingle) {
            this.visible = true
            return
          }
          if (!this.readSingle2) {
            this.visible2 = true
            return
          }
          let params = {
            ...{
              loginPlatform: this.isMobile ? 7 : 6,
              type: 2,
              mobileAreaCode: this.loginNumber.mobileAreaCode,
            },
            ...this.codeForm,
          }
          let res = await Alogin(params)
          if (res.code == 0) {
            this.loginSuccess(res.data)
          } else {
            if (this.isMobile) this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
            else this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          }
        }
      })
    },
    initAWSC(formName) {
      const _this = this
      AWSC.use('nvc', function (state, module) {
        window.nvc = module.init({
          appkey: 'FFFF0N00000000009EB2',
          scene: 'nvc_other',
          success: function (data) {
            _this.checkUserBehavior(data, formName)
          },
          fail: function (failCode) {
            window.console && console.log(failCode)
          },
          error: function (errorCode) {
            window.console && console.log(errorCode)
          },
        })
      })
    },
    haddleCode(formName) {
      this.ncStatus = false
      const _this = this
      this.$refs[formName].validateField('mobile', async (valid) => {
        if (!valid) {
          this.codeStatus = 1
          window.nvc.getNVCValAsync(function (nvcVal) {
            _this.checkUserBehavior(nvcVal, formName)
          })
        }
      })
    },
    /**
     * 获取验证码
     */
    async checkUserBehavior(nvcVal, formName) {
      let mobile = '',
        scene = '',
        mobileAreaCode = ''
      if (formName == 'code-form') {
        mobile = this.codeForm.mobile
        scene = 'vbdata_loginon'
        mobileAreaCode = this.loginNumber.mobileAreaCode
      } else if (formName == 'biding-form') {
        mobile = this.bidingMobileForm.mobile
        scene = 'vbdata_bidingmobile'
        mobileAreaCode = this.loginNumber.mobileAreaCode
      } else if (formName == 'update-form') {
        mobile = this.updateMobileForm.mobile
        scene = 'vbdata_bidingmobile'
        mobileAreaCode = this.loginNumber.mobileAreaCode
      } else {
        mobile = this.currentForm.mobile
        scene = 'vbdata_bidingmobile'
        mobileAreaCode = this.currentForm.mobileAreaCode
      }

        let res = await Achecksendmobliecode({
          data: nvcVal,
          mobile,
          mobileAreaCode,
          scene,
      })
      if (res.code == 0) {
        if (res.data.code == 100 || res.data.code == 200) {
          this.codeStatus = 2
          this.waitInterval = setInterval(() => {
            this.wait--
            if (this.wait == 0) {
              this.codeStatus = 3
              this.wait = 60
              clearInterval(this.waitInterval)
            }
          }, 1000)
          this.ncStatus = false
          if (this.isMobile) this.$notify({ type: 'success', message: filter.dealLanguage('验证码发送成功', 'Verification code sent successfully') })
          else this.$Message.success(filter.dealLanguage('验证码发送成功', 'Verification code sent successfully') )
        } else if (res.data.code == 400) {
          this.ncStatus = true
          var ncoption = {
            renderTo: 'nc',
          }
          this.$nextTick(() => {
            window.nvc.getNC(ncoption)
          })
        } else {
          this.codeStatus = 3
          if (this.isMobile) this.$notify(filter.dealLanguage('验证被拦截，请稍后再试或联系客服', 'Verification blocked, please try again later or contact customer service') )
          else this.$Message.error(filter.dealLanguage('验证被拦截，请稍后再试或联系客服', 'Verification blocked, please try again later or contact customer service'))
        }
      } else {
        this.codeStatus = 3
        if (this.isMobile) this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
        else this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    updateRuleValidate() {
      let params = {}
      const baseRules = {
        code: [{ required: true, message: '请填写正确的验证码', trigger: 'blur' }]
      };

      if (this.loginNumber.mobileAreaCode == '86') {
        params = {
          ...baseRules,
          mobile: [
            { required: true, message: '请输入您的手机号', trigger: 'blur' },
            {
              type: 'number',
              message: '手机号格式不正确',
              trigger: 'blur',
              transform(value) {
                return MOBILE_REGEX.test(value) ? Number(value) : false;
              },
            },
          ],
        };
      } else {
        params = {
          ...baseRules,
          mobile: [
            { required: true, message: '请输入您的手机号', trigger: 'blur' },
          ],
        };
      }
      this.ruleValidate = {...params};
    }
  },
}
export { loginCommon }
